export default __webpack_public_path__ + "static/media/filter.2ec485b0.svg";